export const ROUTE_PATH = {
     PAGE_NOT_FOUND: '404',
     FORBIDDEN: '403',
     HOME_PAGE: 'home-page',
     HOME: 'home',
     HELPER: 'helper',
     LOGIN: 'login',
     PRIVACY_POLICY: 'privacy-policy',
     TERMS_OF_SERVICE: 'terms-of-service',
     DASHBOARD: 'dashboard',
     COURSE_DETAIL: 'course-detail',
     PDF_DETAIL: 'pdf-detail',
     VIDEO_DETAIL: 'video-detail',
     TIMETABLE: 'timetable',
     CALENDAR: 'calendar',
     ADMIN_USERS: 'admin-users',
     ADMIN_MAJORS: 'admin-majors',
     ADMIN_COURSES: 'admin-courses',
     ADMIN_CLASSES: 'admin-classes',
     ADMIN_SEMESTERS: 'admin-semesters',
     PROFILE_SETTINGS: 'profile-settings',
}